<template>
  <div class="side-mes">
    <div
      :class="{ 'order-active': allViewShow }"
      class="side-notice-btn side-del-order side-notice-order"
    >
      <strong @click="allViewShowClose">{{ $t('componentsSidemessage.ignore') }}</strong>
    </div>
    <div :class="{ 'order-active': isOrder }" class="side-notice side-notice-order">
      <ul>
        <li
          style="line-height: 52px;"
          v-if="orderObj.roomOrder && orderObj.roomOrder.orderNoticeSize > 0 && !isOpen"
          @click="openWidnow(orderObj.roomOrder)"
        >
          <span>
            <img src="@/assets/order-notice-icon.png" alt />
          </span>
          <span class="text">{{ orderObj.roomOrder.orderNoticeStr }}</span>
        </li>
      </ul>
      <i
        v-if="orderObj.roomOrder && orderObj.roomOrder.orderNoticeSize > 0 && !isOpen"
        class="close-icon"
        @click="closeOrderNotice"
      ></i>
    </div>

    <div ref="panel" class="panel" :class="{ show: isOpen }">
      <div
        v-if="isTip"
        v-show="
          groupFinance +
            systemNumCopy +
            systemNoticeNumCopy +
            orderNumCopy +
            orderSizeCopy +
            borrowNumCopy +
            cleanNumCopy +
            ctuhotelNumCopy +
            ebkorderMsnNum >
          0
        "
        :class="{ 'tip-hide': tipActive }"
        class="panel-mes-tip"
      >
        <img src="@/assets/tip-bell-icon.png" alt />
        <span class="text">
          {{ $t('componentsSidemessage.youReceive')
          }}{{
            groupFinance +
            systemNumCopy +
            systemNoticeNumCopy +
            orderNumCopy +
            orderSizeCopy +
            borrowNumCopy +
            cleanNumCopy +
            ctuhotelNumCopy +
            ebkorderMsnNum
          }}{{ $t('componentsSidemessage.aNewMessage') }}
        </span>
      </div>
      <div class="panel-header">
        <!-- <div class="panel-btn" ref="panelBtn" @click="togglePanel"></div> -->
      </div>
      <div class="panel-body">
        <ul class="order">
          <div class="title">
            <span class="text">{{ $t('componentsSidemessage.order') }}</span>
            <span class="more" @click="openNotice('1')">
              {{ $t('common.more') }}
              <img class="right-icon" src="@/assets/notice-right-icon.png" alt />
            </span>
          </div>
          <div v-show="orderSizeCopy > 0" class="items" @click="openOrder">
            <span class="text">{{ orderObj.roomOrder.orderNoticeStr }}</span>
            <span v-show="orderSizeCopy > 0" class="red"></span>
            <img class="right-icon" src="@/assets/notice-right-icon.png" alt />
          </div>
          <div
            v-for="(msgItem, index) in ebkorderDrawerMessage"
            :key="index"
            class="items"
            @click="openEbkOrder(msgItem.url)"
          >
            <span class="text">{{ msgItem.msg }}</span>
            <span v-show="msgItem.num > 0" class="red"></span>
            <img class="right-icon" src="@/assets/notice-right-icon.png" alt />
          </div>
          <div v-show="orderNumCopy > 0" class="items" @click="openNotice('1')">
            <span class="text"
              >{{ $t('componentsSidemessage.have') }} {{ orderNumCopy
              }}{{ $t('componentsSidemessage.orderMessage') }}</span
            >
            <span v-show="orderNumCopy > 0" class="red"></span>
            <img class="right-icon" src="@/assets/notice-right-icon.png" alt />
          </div>
          <div v-show="orderSizeCopy == 0 && orderNumCopy == 0" class="no-data">
            {{ $t('componentsSidemessage.noData') }}
          </div>
        </ul>
        <ul class="system">
          <div class="title">
            <span class="text">{{ $t('componentsSidemessage.system') }}</span>
            <span class="more" @click="openNotice('4')">
              {{ $t('common.more') }}
              <img class="right-icon" src="@/assets/notice-right-icon.png" alt />
            </span>
          </div>
          <div v-show="systemNoticeNumCopy > 0" class="items" @click="openNotice('4')">
            <span
              >{{ $t('componentsSidemessage.youReceive') }} {{ systemNoticeNumCopy }}
              {{ $t('componentsSidemessage.aNewSystemMessage') }}</span
            >
            <span v-show="systemNoticeNumCopy > 0" class="red"></span>
            <img class="right-icon" src="@/assets/notice-right-icon.png" alt />
          </div>
          <div v-show="systemNoticeNumCopy == 0" class="no-data">
            {{ $t('componentsSidemessage.noData') }}
          </div>
        </ul>
        <!-- 结算 -->
        <ul class="system">
          <div class="title">
            <span class="text">{{ $t('componentsSidemessage.settlement') }}</span>
            <span class="more" @click="openNotice('3')">
              {{ $t('common.more') }}
              <img class="right-icon" src="@/assets/notice-right-icon.png" alt />
            </span>
          </div>
          <div v-show="groupFinance > 0" class="items" @click="openNotice('3')">
            <span
              >{{ $t('componentsSidemessage.youReceive') }} {{ groupFinance }}
              {{ $t('componentsSidemessage.aNewSettlementMessage') }}</span
            >
            <span v-show="groupFinance > 0" class="red"></span>
            <img class="right-icon" src="@/assets/notice-right-icon.png" alt />
          </div>
          <div v-show="groupFinance == 0" class="no-data">
            {{ $t('componentsSidemessage.noData') }}
          </div>
        </ul>
        <!-- 动态消息 -->
        <ul class="system">
          <div class="title">
            <span class="text">{{ $t('componentsSidemessage.dynamic') }}</span>
            <span class="more" @click="openNotice('2')">
              {{ $t('common.more') }}
              <img class="right-icon" src="@/assets/notice-right-icon.png" alt />
            </span>
          </div>
          <div v-show="systemNumCopy > 0" class="items" @click="openNotice('2')">
            <span
              >{{ $t('componentsSidemessage.youReceive') }} {{ systemNumCopy }}
              {{ $t('componentsSidemessage.aNewSystemMessage') }}</span
            >
            <span v-show="systemNumCopy > 0" class="red"></span>
            <img class="right-icon" src="@/assets/notice-right-icon.png" alt />
          </div>
          <div v-show="systemNumCopy == 0" class="no-data">
            {{ $t('componentsSidemessage.noData') }}
          </div>
        </ul>
        <ul class="service">
          <div class="title">{{ $t('componentsSidemessage.serviceManagement') }}</div>
          <div class="items" @click="openService('1')">
            <img class="left-icon" src="@/assets/room-notice-icon.png" alt />
            <span class="text">{{ $t('componentsSidemessage.roomService') }}</span>
            <span v-show="cleanNumCopy > 0" class="red"></span>
            <img class="right-icon" src="@/assets/notice-right-icon.png" alt />
          </div>
          <div class="items" @click="openService('2')">
            <img class="left-icon" src="@/assets/borrom-notice-icon.png" alt />
            <span class="text">{{ $t('componentsSidemessage.itemBorrow') }}</span>
            <span v-show="borrowNumCopy > 0" class="red"></span>
            <img class="right-icon" src="@/assets/notice-right-icon.png" alt />
          </div>
          <div class="items" @click="openService('3')">
            <img class="left-icon" src="@/assets/ctu-hotel.png" alt />
            <span class="text">{{ $t('componentsSidemessage.extendStay') }}</span>
            <span v-show="ctuhotelNumCopy > 0" class="red"></span>
            <img class="right-icon" src="@/assets/notice-right-icon.png" alt />
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderDetail, getServiceNumber } from '@/api/stock';
import { ebkOrderDrawerMessage, confirmOrder } from '../../api/ebkOrder';
import { helpJsonParse } from '@/utils/index';
import { mapGetters } from 'vuex';
export default {
  name: 'SideMessage',
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      allViewShow: false,
      element: null,
      orderNumCopy: 0,
      systemNumCopy: 0,
      systemNoticeNumCopy: 0,
      orderSizeCopy: 0,
      cleanNumCopy: 0,
      borrowNumCopy: 0,
      ctuhotelNumCopy: 0,
      groupFinance: 0,

      noticeFlag: localStorage.getItem('noticeFlag')
        ? helpJsonParse(localStorage.getItem('noticeFlag'))
        : 0,
      isDisplay: false, // 判断引导是否已展示
      isGudie: false, // 判断是否展示提示
      isShaky: false, // 抖动
      isOpen: false, // 显示侧边栏
      isOrder: false,
      orderObj: {
        roomOrder: {
          orderNoticeSize: 0,
        },
      },
      ebkorderDrawerMessage: [],
      ebkorderMsnNum: 0,
      isCheck: false,
      lastHeight: 0,
      // orderEleHeight: 78,
      orderEleHeight: 140,
      bellTimer: null,
      orderTimer: null,
      bellTimer1: null,
      tipTimer: null,
      tipActive: false,
      isTip: false,
      isFirstRequest: true,
      notifications: {}, // 消息字典，只查eb搬单弹窗消息
      serviceNoticeArr: [],
      clickOnTheSmallBellToDelay: true,
      viewCardShow: localStorage.getItem('viewCardShow'),
    };
  },
  computed: {
    ...mapGetters(['authList']),
    sideMessageOccupied() {
      // Layout 的 v-show 为 false 时组件仍会保留，不能以内部状态持续压制 AI 悬浮窗。
      return this.visible && (this.isOpen || this.isOrder);
    },
  },
  watch: {
    sideMessageOccupied: {
      handler(active) {
        this.$store.commit('app/SET_AI_FLOAT_SUPPRESSOR', { name: 'sideMessage', active });
      },
      immediate: true,
    },
    isCheck(newValue) {
      if (newValue) {
        this.orderSizeCopy = 0;
        this.orderNumCopy = 0;
        this.systemNumCopy = 0;
        this.systemNoticeNumCopy = 0;
        this.borrowNumCopy = 0;
        this.ctuhotelNumCopy = 0;
        this.groupFinance = 0;
        this.cleanNumCopy = 0;
        this.isCheck = false;
        this.isOpen = false;
      }
    },
    orderObj: {
      deep: true,
      handler: function (newValue, oldValue) {
        // var isHeight = document.getElementsByClassName('side-notice-order')[0]
        //   .offsetHeight
        if (!newValue.roomOrder) {
          this.$nextTick(() => {
            this.moveServiceBox(oldValue);
          });
        }
        if (newValue.roomOrder && !this.isOpen) {
          if (!this.isOrder) {
            this.$nextTick(() => {
              this.moveServiceBox();
            });
          }
          this.isOrder = true;
          this.orderTimer = setTimeout(() => {
            this.isOrder = false;
            clearTimeout(this.orderTimer);
          }, 2500);
        } else {
          this.isOrder = false;
        }
      },
    },
    '$store.state.app.notificationDisplay'(val) {
      this.clickOnTheSmallBellToDelay = false;
      setTimeout(() => {
        this.clickOnTheSmallBellToDelay = true;
      });
      this.togglePanel();
    },
    '$store.getters.socketMessage'(msg) {
      console.log(msg);
      const { type, childrenType } = msg;
      if (type === 'socket' && childrenType === 'order') {
        console.log(this.$t('componentsSidemessage.orderNotice'), msg);
        this.calcMessageNumberByType(type, childrenType);
        if (this.isOpen) this.isTip = true;
      }
      if (type === 'socket' && childrenType === 'socketOrder') {
        console.log('socketOrder通知', msg);
        this.calcMessageNumberByType(type, childrenType);
        if (this.isOpen) this.isTip = true;
        if (!this.isOpen) this.openServiceNotice(msg);
      }
      if (type === 'message' && childrenType === 'groupFinance') {
        console.log(this.$t('componentsSidemessage.settlement'), msg);
        this.calcMessageNumberByType(type, childrenType);
        if (this.isOpen) this.isTip = true;
        if (!this.isOpen) this.openServiceNotice(msg);
      }
      if (type === 'message' && childrenType === 'systemNotice') {
        this.calcMessageNumberByType(type, childrenType);
        if (this.isOpen) this.isTip = true;
      }
      if (
        (type === 'roomTask' && ['cleanTask', 'articleBorrow'].includes(childrenType)) ||
        (type === 'message' && ['system'].includes(childrenType))
      ) {
        this.calcMessageNumberByType(type, childrenType);
        if (this.isOpen) this.isTip = true;
        if (!this.isOpen) this.openServiceNotice(msg);
      }
    },
    isTip(newValue) {
      if (newValue) {
        this.tipTimer = setTimeout(() => {
          this.tipActive = true;
          this.isTip = false;
          clearTimeout(this.tipTimer);
        }, 3500);
      }
      if (!newValue) {
        this.tipActive = false;
      }
    },
  },
  created() {
    // this.getOrderDetail()
    this.getServiceNumber();
  },
  mounted() {
    this.$nextTick(() => {
      this.element = this.$refs.panel;
    });
    document.addEventListener(
      'click',
      (e) => {
        this.$nextTick(() => {
          if (this.isOpen && this.clickOnTheSmallBellToDelay) {
            if (!this.element.contains(e.target)) {
              this.isOpen = false;
            }
          }
        });
      },
      false
    );
    window.jumpOrderListNew = this.jumpOrderListNew;

    //监听跨浏览器弹窗标识
    window.addEventListener('storage', (e) => {
      if (e.newValue != 'true' && e.key == 'allCardNotice') {
        this.allViewShowCloseNostorage();
      }
      // console.log("别的浏览器页签storage发生变化啦:", e)
    });
    window.addEventListener('setItemEvent', (e) => {
      if (e.newValue != 'true' && e.key == 'allCardNotice') {
        this.allViewShowCloseNostorage();
      }
      // console.log("localStorage值发生变化后触发:", e.newValue);
    });
  },
  beforeDestroy() {
    this.$store.commit('app/SET_AI_FLOAT_SUPPRESSOR', { name: 'sideMessage', active: false });
  },
  methods: {
    calcMessageNumberByType(type, childrenType) {
      if (type === 'roomTask' && childrenType === 'cleanTask') {
        this.cleanNumCopy += 1;
      } else if (type === 'roomTask' && childrenType === 'articleBorrow') {
        this.borrowNumCopy += 1;
      } else if (type === 'message' && childrenType === 'system') {
        this.systemNumCopy += 1;
      } else if (type === 'message' && childrenType === 'systemNotice') {
        this.systemNoticeNumCopy += 1;
      } else if (type === 'message' && childrenType === 'order') {
        this.orderNumCopy += 1;
        console.log(
          this.$t('componentsSidemessage.orderMessageReceivedNotification'),
          this.orderNumCopy
        );
      } else if (type === 'socket' && childrenType === 'order') {
        this.orderNumCopy += 1;
      } else if (type === 'message' && childrenType === 'groupFinance') {
        // 结算消息
        this.groupFinance += 1;
      }
      this.calculateTheNumberOfSystemMessages();
    },
    openOrder() {
      window.open(`${window.origin}/guest/roomOrder/list/1`);
    },
    openEbkOrder(url) {
      window.open(`${window.origin}${url}`);
    },
    openNotice(index) {
      this.isCheck = true;
      window.open(`${window.origin}/ordernotice#${index}`);
    },
    openService(index) {
      this.isCheck = true;
      window.open(`${window.origin}/servicemanage#${index}`);
    },
    getServiceNumber() {
      getServiceNumber()
        .then((res) => {
          const messageListEnum = {};
          res.data.map((item) => {
            messageListEnum[item.typeCode] = item;
          });
          const {
            order,
            system,
            systemNotice,
            cleanTask,
            articleBorrow,
            applyContinuedResidence,
            groupFinance,
          } = messageListEnum;
          this.orderNumCopy = order.number;
          this.systemNumCopy = system.number;
          this.systemNoticeNumCopy = systemNotice.number;
          this.cleanNumCopy = cleanTask.number;
          this.borrowNumCopy = articleBorrow.number;
          this.ctuhotelNumCopy = applyContinuedResidence.number;
          this.groupFinance = groupFinance.number;
          // if (this.orderNum > 0 || this.systemNum > 0 || this.cleanNum > 0 || this.borrowNum > 0) this.isTip = true
          this.calculateTheNumberOfSystemMessages();
        })
        .catch(() => {});
    },
    // 计算系统消息数量
    calculateTheNumberOfSystemMessages() {
      let systemMessage =
        this.cleanNumCopy +
        this.borrowNumCopy +
        this.orderNumCopy +
        this.systemNumCopy +
        this.systemNoticeNumCopy +
        this.ctuhotelNumCopy +
        this.groupFinance;
      this.$store.commit('app/SET_SYSTEM_MESSAGE', systemMessage);
    },
    // 打开侧边栏
    togglePanel() {
      this.isShaky = false;
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        var eleArr = document.getElementsByClassName('side-notice-service');
        this.$nextTick(() => {
          for (let i = 0; i < eleArr.length; i++) {
            eleArr[i].style.diaplay = 'none';
            eleArr[i].style.visibility = 'hidden';
          }
          for (let i = 0; i < eleArr.length; i++) {
            eleArr[i].remove();
          }
        });
      }
    },
    // 打开订单页面呢
    openWidnow(item) {
      window.open(`${window.origin}${item.url}`);
    },
    // 关闭消息框
    closeOrderNotice() {
      if ((this.noticeFlag === 0 || !this.noticeFlag) && !this.isDisplay) {
        this.isGudie = true;
        localStorage.setItem('noticeFlag', 1);
      }
      this.isShaky = true;
      this.isOrder = false;
      this.isDisplay = true;
      this.moveServiceBox();
      this.bellTimer = setTimeout(() => {
        this.isShaky = false;
        clearTimeout(this.bellTimer);
      }, 2000);
    },
    // 移动消息框
    moveServiceBox(orderObj) {
      var orderEleHeight = document.getElementsByClassName('side-notice-order')[0].offsetHeight;
      var eleArr = document.getElementsByClassName('side-notice-service');
      for (let i = 0; i < eleArr.length; i++) {
        if (orderEleHeight > 0) {
          eleArr[i].style.top =
            Number(eleArr[i].style.top.split('px')[0]) + Number(orderEleHeight) + 'px';
        } else {
          eleArr[i].style.top = eleArr[i].style.top.split('px')[0] - this.lastHeight + 'px';
        }
      }
    },
    jumpOrderListNew(orderNumber) {
      let routeOne = this.$router.resolve({
        path: '/guest/ebkorder',
        query: {
          channelCode: orderNumber,
          date: new Date().getTime(),
        },
      });
      window.open(routeOne.href, '_blank');
    },
    // 关闭所有弹窗和卡片
    allViewShowClose() {
      this.serviceNoticeArr.map((item) => {
        item.close();
      });
      this.allViewShow = false;
      localStorage.setItem('allCardNotice', false);
      // this.closeOrderNotice();
    },
    allViewShowCloseNostorage() {
      this.serviceNoticeArr.map((item) => {
        item.close();
      });
      this.allViewShow = false;
    },
    allViewShowOpen() {
      this.allViewShow = true;
      localStorage.setItem('allCardNotice', true);
    },
    // 打开消息服务
    openServiceNotice(data) {
      var that = this;
      var htmlStr = '';
      var orderHtml = '';
      var groupFinance = '';
      var orderRoomHtml = '';
      let EBOrderMessageCardData = null;
      var systemHtml = `<a target="_blank" href="/comment/complain">
                      <div ref="service" class="notice service">
                          <span class="text">${data.context}</span>
                          <i  class="close-icon"></i>
                      </div>
                    </a>
                  `;

      if (
        data.childrenType === 'order' &&
        data.hasOwnProperty('context') &&
        helpJsonParse(data.context).hasOwnProperty('ebkType') &&
        helpJsonParse(data.context).hasOwnProperty('popOrCard')
      ) {
        let _popOrCard = helpJsonParse(data.context).popOrCard;
        let _data = helpJsonParse(data.context);
        console.log(_data);
        switch (_popOrCard) {
          case 1:
            // EB搬单弹窗卡片消息
            EBOrderMessageCardData = this.createdEBOrderMessageCard(data);
            break;
          case 2:
            // EB搬单卡片消息
            htmlStr = `
              <div onclick="jumpOrderListNew('${_data.orderNumber}')">
                <p>${_data.channelName}</p>
                <p>客人姓名：${_data.guestName} 联系电话：${_data.phone}</p>
                <p>${_data.channelOrderNo}</p>
              </div>
            `;
            break;
        }
      } else {
        if (data.childrenType === 'order' || data.childrenType === 'socketOrder') {
          var orderStr = helpJsonParse(data.context);
          var orderUrl = '';
          if (orderStr.url === '/guest/order/orderDetail/detail') {
            orderUrl = `/guest/order/orderDetail/detail?orderNo=${orderStr.param}`;
          } else if (orderStr.url === '/guest/roomOrder/roomOrderDetail/detail') {
            orderUrl = `/guest/roomOrder/roomOrderDetail/detail?orderNo=${orderStr.orderNumber}&orderRoomNo=${orderStr.orderRoomNo}`;
          } else if (orderStr.url === '/guest/ebkorder') {
            orderUrl = `/guest/ebkorder`;
          } else if (orderStr.url === '/guest/order/list/7') {
            orderUrl = orderStr.url;
          } else if (orderStr.url === '') {
            orderUrl = `/guest/roomOrder/roomOrderDetail/detail?orderRoomNo=${orderStr.orderRoomNo}`;
          } else {
            orderUrl = '/guest/roomOrder/list/1';
          }
          orderHtml = `<a target="_blank" href="${orderUrl}">
                    <div ref="service" class="notice service icon">
                        <span class="icon"></span>
                        <span class="text">${orderStr.content}</span>
                        <i  class="close-icon"></i>
                    </div>
                  </a>
                `;
          // orderRoomHtml是钟点房单独的逻辑，显示title，产品耿彬彬
          // 自助机也加了个房单入住提示
          orderRoomHtml = `<a target="_blank" href="${orderUrl}">
                    <div ref="service" class="notice service icon">
                        <span class="icon"></span>
                        <span class="text">${orderStr.alertMsg || orderStr.content}</span>
                        <i  class="close-icon"></i>
                    </div>
                  </a>
                `;
        }
        // 结算
        if (data.childrenType === 'groupFinance') {
          let groupFinan = data;
          groupFinance = `
                  <a target="_blank" href="/ordernotice#3">
                      <div ref="service" class="notice service">
                        <span class="iconFX"></span>
                          <span class="text">${groupFinan.context}</span>
                          <i class="close-icon"></i>
                      </div>
                  </a>
                `;
          htmlStr = groupFinance;
        }
        if (data.childrenType === 'order' || data.childrenType === 'socketOrder') {
          if (orderStr.url === '/guest/roomOrder/roomOrderDetail/detail') {
            htmlStr = orderRoomHtml;
          } else {
            htmlStr = orderHtml;
          }
        }
        if (data.childrenType === 'system') {
          htmlStr = systemHtml;
        }
        if (data.childrenType === 'articleBorrow') {
          let context = JSON.parse(data.context);
          htmlStr = `<a target="_blank" href="/setting/borrow/record">
                    <div ref="service" class="notice service icon">
                        <span class="icon"></span>
                        <span class="text">${context.content}</span>
                        <i  class="close-icon"></i>
                    </div>
                  </a>`;
        }
      }
      if (this.serviceNoticeArr.length < 1) {
        this.allViewShowOpen();
      }
      this.$nextTick(() => {
        this.serviceNotice = this.$notify({
          title: '',
          duration: this.setNotifyDuration(data),
          offset: this.orderEleHeight,
          onClose: (event) => {
            if ((this.noticeFlag === 0 || !this.noticeFlag) && !this.isDisplay) {
              that.isGudie = false;
            }
            that.isDisplay = true;
            if (that.isOpen) that.isShaky = true;
            that.bellTimer1 = setTimeout(() => {
              that.isShaky = false;
              clearTimeout(that.bellTimer1);
            }, 2000);
            this.computedNotify(event);
          },
          onClick: () => {},
          customClass: this.setCustomClass(data),
          dangerouslyUseHTMLString: true,
          message: EBOrderMessageCardData ? EBOrderMessageCardData.renderHtml : htmlStr,
        });
        EBOrderMessageCardData &&
          (this.notifications[EBOrderMessageCardData.channelOrderNo] = this.serviceNotice);
        this.serviceNoticeArr.push(this.serviceNotice);
        console.log(this.serviceNoticeArr);
      });
    },
    computedNotify(e) {
      if (this.serviceNoticeArr.length > 0) {
        this.serviceNoticeArr = this.serviceNoticeArr.filter((item) => {
          return item != e;
        });
        if (this.serviceNoticeArr.length == 0) {
          this.allViewShow = false;
        }
      } else {
        this.allViewShow = false;
      }
    },
    // 得到订单列表
    getOrderDetail() {
      // this.getServiceNumber()
      getOrderDetail()
        .then((res) => {
          if (res && res.code === '0') {
            res.data.forEach((item) => {
              if (item.url.indexOf('/guest/roomOrder/list') > -1) {
                this.orderObj.roomOrder = item;
              }
              this.orderSizeCopy = this.orderObj.roomOrder.orderNoticeSize;
              // if (this.orderSizeCopy > 0) this.isTip = true
            });
          }
        })
        .catch(() => {});
      ebkOrderDrawerMessage()
        .then((res) => {
          if (res.code === '0') {
            this.ebkorderMsnNum = res.data.totalNum;
            this.ebkorderDrawerMessage = res.data.msg;
          }
        })
        .catch(() => {});
    },
    /**
     * 设置自动关闭时间
     * ebkType EBK消息
     * popOrCard 1 - EBK弹窗消息 2 - EBK卡片消息 3 - 异常
     */
    setNotifyDuration(data) {
      let times = 2500;

      if (
        data.childrenType === 'socketOrder' ||
        (data.childrenType === 'order' &&
          helpJsonParse(data.context).hasOwnProperty('ebkType') &&
          helpJsonParse(data.context).hasOwnProperty('popOrCard') &&
          helpJsonParse(data.context).popOrCard == 1)
      ) {
        times = 0;
      }
      return times;
    },
    /**
     * 设置自定义class
     */
    setCustomClass(data) {
      let className = '';
      if (
        data.childrenType === 'order' &&
        helpJsonParse(data.context).hasOwnProperty('ebkType') &&
        helpJsonParse(data.context).hasOwnProperty('popOrCard')
      ) {
        let _popOrCard = helpJsonParse(data.context).popOrCard;
        _popOrCard == 1 && (className = 'card-message-class');
        _popOrCard == 2 && (className = 'card-message');
      } else {
        className = 'side-notice-service side-notice';
      }
      return className;
    },
    /**
     * 创建EB搬单数据
     */
    createdEBOrderMessageCard(data) {
      const h = this.$createElement;
      let item = helpJsonParse(data.context);
      console.log(item);
      let renderHtml = h(
        'div',
        {
          class: 'order-message',
        },
        [
          h('div', { class: 'header' }, [
            h('div', { class: 'common event-name' }, item.titleName),
            h(
              'div',
              {
                class:
                  item.orderTypeButton == 3 || item.orderTypeButton == 4
                    ? 'common icon'
                    : 'common icon hide',
              },
              [h('div', { class: 'err-message' }, item.failReason)]
            ),
          ]),
          h('ul', { class: 'order-infor' }, [
            h('li', { class: 'msg-list' }, [
              h('div', { class: 'lf item-name' }, this.$t('common.roomType')),
              h('div', { class: 'item-value' }, `${item.roomType} ${item.checkInRoomCount}`),
            ]),
            h('li', { class: 'msg-list' }, [
              h('div', { class: 'lf item-name' }, this.$t('common.checkInType')),
              h('div', { class: 'item-value' }, item.checkInType + (item.checkInHour || '')),
            ]),
            h('li', { class: 'msg-list' }, [
              h('div', { class: 'lf item-name' }, this.$t('common.checkInOutDate')),
              h('div', { class: 'item-value' }, item.chenckInAndOut),
            ]),
            h('li', { class: 'msg-list' }, [
              h('div', { class: 'lf item-name' }, this.$t('common.channelOrderNo')),
              h(
                'div',
                {
                  class: 'item-value color-text',
                  on: {
                    click: this.jumpEBKOrderList.bind(this, item),
                  },
                },
                item.channelOrderNo
              ),
            ]),
            h(
              'li',
              {
                class: item.orderTypeButton > 3 ? 'msg-list' : 'msg-list hide',
              },
              [
                h('div', { class: 'lf item-name' }, this.$t('common.qzOrderNo')),
                h(
                  'div',
                  {
                    class: 'item-value color-text',
                    on: {
                      click: this.jumpOrderList.bind(this, item),
                    },
                  },
                  item.qzOrderNo
                ),
              ]
            ),
          ]),
          h('div', { class: 'btn-group' }, [
            h(
              'span',
              {
                class: item.orderTypeButton < 4 ? '' : 'hide',
                on: {
                  click: this.jumpEBKOrderList.bind(this, item),
                },
              },
              this.$t('componentsSidemessage.manualEntry')
            ),
            h(
              'span',
              {
                class: item.orderTypeButton == 2 ? '' : 'hide',
                on: {
                  click: this.hourRoomOrder.bind(this, item),
                },
              },
              this.$t('componentsSidemessage.confirmOrder')
            ),
            h(
              'span',
              {
                class: item.orderTypeButton > 3 ? '' : 'hide',
                on: {
                  click: this.jumpEBKOrderList.bind(this, item),
                },
              },
              this.$t('componentsSidemessage.viewOrder')
            ),
          ]),
        ]
      );
      return {
        renderHtml,
        channelOrderNo: item.channelOrderNo,
      };
    },
    /**
     * 渠道单号/手工录入 跳转EBK订单列表
     */
    jumpEBKOrderList(data) {
      let { status = false, channelCode } = this.closeCurrNotify(data);
      if (!status) return;
      // 设置跳转
      let flag = false;
      this.authList.find((ele) => {
        if (
          ele.hasOwnProperty('name') &&
          ele.hasOwnProperty('path') &&
          ele.name == 'Guest' &&
          ele.path == '/guest' &&
          ele.hasOwnProperty('children')
        ) {
          ele.children.find((children) => {
            children.path && children.path == '/guest/ebkorder' && (flag = true);
          });
        }
      });
      if (flag) {
        let routeOne = this.$router.resolve({
          path: '/guest/ebkorder',
          query: {
            channelCode,
            date: new Date().getTime(),
          },
        });
        window.open(routeOne.href, '_blank');
      } else {
        this.$message.warning(
          this.$t('componentsSidemessage.youDoNotHaveAccessToEbkOrderManagement')
        );
      }
    },
    /**
     * 轻住订单号 跳转订单列表
     */
    jumpOrderList(data) {
      let { status = false, channelCode } = this.closeCurrNotify(data);
      if (!status) return;
      // 设置跳转
      let flag = false;
      this.authList.find((ele) => {
        if (
          ele.hasOwnProperty('name') &&
          ele.hasOwnProperty('path') &&
          ele.name == 'Guest' &&
          ele.path == '/guest' &&
          ele.hasOwnProperty('children')
        ) {
          ele.children.find((g_children) => {
            if (
              g_children.hasOwnProperty('name') &&
              g_children.hasOwnProperty('path') &&
              g_children.name == 'Order' &&
              g_children.path == '/guest/order' &&
              g_children.hasOwnProperty('children')
            ) {
              g_children.children.find((o_children) => {
                o_children.path && o_children.path == '/guest/order/list/7' && (flag = true);
              });
            }
          });
        }
      });
      if (flag) {
        let routeOne = this.$router.resolve({
          path: '/guest/order/list/6',
          query: {
            channelCode,
            date: new Date().getTime(),
          },
        });
        window.open(routeOne.href, '_blank');
      } else {
        this.$message.warning(
          this.$t('componentsSidemessage.youDoNotHaveOrderManagementPermission')
        );
      }
    },
    /**
     * 钟点房接单
     */
    hourRoomOrder(data) {
      let { status = false, channelCode } = this.closeCurrNotify(data);
      status && confirmOrder({ channelOrderNo: channelCode });
    },
    /**
     * 数据检查
     */
    closeCurrNotify(data) {
      if (!(data && data.hasOwnProperty('channelOrderNo'))) {
        console.log('[error]: 没有渠道参数[channelOrderNo]');
        return {
          status: false,
          channelCode: '',
        };
      }
      // 关闭弹窗
      let _channelCode = data.channelOrderNo;
      this.notifications[_channelCode].close();
      delete this.notifications[_channelCode];
      return {
        status: true,
        channelCode: _channelCode,
      };
    },
    formatPhoneNumber(val) {
      if (!val) return '';
      return val.toString().substring(0, 3) + '****' + val.toString().substring(7, 11);
    },
  },
};
</script>
<style lang="scss">
.sidemes-dialog {
  .el-dialog__footer {
    padding: 0px;
  }

  .dialog-footer {
    display: block;
    padding-right: 30px;

    button:first-child {
      width: 60px;
      height: 28px;
      padding: 0px;
      line-height: 28px;
      border-radius: 4px;
      border: 1px solid rgba(4, 109, 187, 1);
      color: rgba(4, 109, 187, 1);
      background: #fff;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }
  }
}

.side-mes .side-notice-order.side-del-order {
  width: 88px;
  height: 30px;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(50, 75, 130, 0.2);
  border-radius: 15px;
  border: 1px solid #ffffff;
  line-height: 28px;
  text-align: center;
  top: 115px;
  cursor: pointer;

  strong {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
}

.side-mes .side-notice-order.side-del-order:hover {
  background: #f7f8fc;
}

.side-notice-service {
  width: 366px;
  right: 70px !important;
  padding: 0px;
  cursor: pointer;

  .el-notification__group,
  .el-notification__content {
    margin: 0px;
  }

  .service {
    position: relative;
    width: 366px;
    padding: 20px 46px 20px 20px;
    display: flex;
    justify-content: space-between;

    .text {
      width: 86%;
      text-align: left;
      word-break: break-all;
    }

    .icon {
      width: 20px;
      height: 20px;
      background-image: url('../../assets/order-notice-icon.png');
      background-size: 20px 20px;
      background-repeat: no-repeat;
    }

    .iconFX {
      width: 20px;
      height: 20px;
      background-image: url('../../assets/iconfx.png');
      background-size: 20px 20px;
      background-repeat: no-repeat;
    }
  }

  .el-notification__closeBtn {
    position: absolute;
    right: 10px;
    top: 22px;
    display: block;
    width: 16px;
    height: 16px;
    background-image: url('../../assets/icon-close.png');
    background-size: 100% 100%;
    background-color: #d1d1d1;
    border-radius: 50%;
  }
}

.sidemes-dialog {
  .el-dialog__body {
    padding: 0px 30px;

    .text {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(79, 81, 97, 1);
    }

    .tip {
      padding: 10px 0;
      border-bottom: 1px solid #edeef4;
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(114, 116, 129, 1);
    }

    .label {
      margin-top: 30px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(123, 124, 137, 1);
    }

    .radio {
      height: 40px;
      line-height: 40px;
      margin-bottom: 20px;
    }
  }

  .el-dialog__header {
    height: 70px;
    line-height: 70px;
    font-size: 22px;
    padding-left: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(35, 37, 58, 1);
  }

  .el-dialog__body {
    height: 312px;
  }

  .el-dialog__footer {
    height: 70px;
    line-height: 70px;

    .cancel-btn {
      height: 30px;
      min-width: auto;
      line-height: 30px;
      padding: 0 14px;
      font-size: 14px;
    }

    .submit-btn {
      height: 30px;
      min-width: auto;
      line-height: 30px;
      padding: 0 14px;
      font-size: 14px;
    }
  }
}

.side-mes {
  .model {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
  }

  .guide {
    position: absolute;
    right: 20px;
    top: 60px;
  }

  .guide-arrow {
    content: ' ';
    width: 0;
    height: 0;
    margin-left: 200px;
    border-width: 0 8px 10px;
    border-style: solid;
    border-color: transparent transparent rgba(0, 0, 0, 0.8);
    /*透明 透明  灰*/
  }

  .guide-content {
    position: absolute;
    width: 230px;
    height: 94px;
    background: rgba(0, 0, 0, 1);
    border-radius: 4px;
    opacity: 0.8;
    color: #fff;
    font-size: 14px;
    padding-left: 20px;
    text-align: left;
  }

  .guide {
    position: absolute;
    right: 20px;
  }

  .guide-btn {
    position: absolute;
    top: 65px;
    right: 0px;
    width: 64px;
    height: 26px;
    line-height: 26px;
    background: rgba(0, 0, 0, 1);
    border-radius: 2px;
    color: #fff;
    font-size: 13px;
  }

  .tip-hide {
    top: -40px;
    opacity: 0;
  }

  .shaky {
    animation: alarm-2 0.4s infinite;
  }

  @keyframes alarm-2 {
    0% {
      transform: rotate(30deg) scale(1);
    }

    25% {
      transform: rotate(0deg) scale(1.5);
    }

    50% {
      transform: rotate(-30deg) scale(1.5);
    }

    75% {
      transform: rotate(0deg) scale(1.5);
    }

    100% {
      transform: rotate(30deg) scale(1);
    }
  }

  div.service-active {
    right: 70px;
  }

  div.order-active {
    right: 70px;
  }

  .side-notice {
    transition: opacity 0.3s, transform 0.3s, left 0.6s, right 0.6s, top 0.4s, bottom 0.3s,
      -webkit-transform 0.3s;
  }

  .side-notice-btn {
    transition: opacity 0.3s, transform 0.3s, left 0.3s, right 0.3s, top 0.4s, bottom 0.3s;
  }

  .close-icon {
    position: absolute;
    right: 10px;
    top: 17px;
    display: block;
    width: 16px;
    height: 16px;
    background-image: url('../../assets/icon-close.png');
    background-size: 100% 100%;
    background-color: #d1d1d1;
    border-radius: 50%;
  }

  .side-notice-service {
    width: 366px;
    top: 248px;
    right: -440px;
    padding: 20px 48px 20px 20px;
    position: absolute;
    z-index: 2000;
    background: #fff;
    box-shadow: 0px 10px 20px 0px rgba(40, 54, 65, 0.15);
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(79, 81, 97, 1);
  }

  .side-notice-order {
    width: 366px;
    // height: 168px;
    top: 68px;
    right: -440px;
    position: absolute;
    z-index: 2000;
    background: #fff;
    box-shadow: 0px 10px 20px 0px rgba(40, 54, 65, 0.15);
    border-radius: 4px;

    li {
      display: flex;
      justify-content: space-between;

      span {
        display: inline-block;
      }

      .text {
        width: 90%;

        p {
          height: 16px;
        }

        div {
          min-height: 20px;
        }
      }

      img {
        height: 20px;
        width: 20px;
        margin: 16px 0px;
      }

      min-height: 52px;
      margin: 0 36px 0 20px;
      border-bottom: 1px solid rgba(230, 232, 240, 0.5);
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(79, 81, 97, 1);
    }

    li:last-child {
      border-bottom: none;
    }

    .num {
      color: rgba(4, 109, 187, 1);
    }

    // }
  }

  .panel {
    position: fixed;
    height: 100%;
    // background: #fff;
    top: 58px;
    right: 0px;
    z-index: 10;
    background: #fff;
    box-shadow: -10px 10px 20px 0px rgba(40, 54, 65, 0.15);
    transform: translate(100%);
    transition: all 0.25s cubic-bezier(0.7, 0.3, 0.1, 1);
  }

  .show {
    transform: translate(0%);
  }

  .tooltip {
    display: block;
    width: 230px;
    height: 90px;
    padding: 20px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }

  .panel-mes-tip {
    display: flex;
    padding-left: 10px;
    justify-content: space-between;
    width: 330px;
    position: absolute;
    top: 13px;
    right: 20px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 4px;
    background: #fa750f;
    color: #fff;
    font-size: 14px;
    transition: opacity 0.3s, transform 0.3s, left 0.6s, right 0.6s, top 0.4s, bottom 0.3s,
      -webkit-transform 0.3s;

    img {
      width: 20px;
      height: 20px;
      margin: 10px 0;
    }

    .text {
      width: 90%;
      text-align: left;
    }
  }

  .panel-title {
    width: 340px;
    height: 60px;
    line-height: 60px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(35, 37, 58, 1);
    background: #fff;
  }

  .panel-header {
    .panel-btn {
      // width: 60px;
      height: 64px;
      line-height: 60px;
      margin: 0px;
      text-align: center;
      position: absolute;
      top: 0px;
      left: -60px;
      cursor: pointer;
      border-top-left-radius: 50%;
      border-bottom-left-radius: 50%;
      background-image: url('../../assets/bell-bg-icon.png');
      background-size: 100% 100%;

      .el-badge .el-badge__content {
        // border-radius: 2px;
        background: linear-gradient(180deg, rgba(255, 138, 93, 1) 0%, rgba(252, 104, 48, 1) 100%);
      }

      .btn-warp {
        width: 32px;
        height: 32px;
        line-height: 32px;
        border-radius: 50%;
        background: rgba(244, 245, 249, 1);
        margin: 17px 14px;
        padding: 5px;

        img {
          width: 22px;
          height: 22px;
        }
      }
    }
  }

  .panel-body {
    margin-top: 64px;
    max-height: calc(100vh - 150px);
    overflow-y: auto;
    -ms-overflow-style: none; /* IE 和 Edge（老版） */
    scrollbar-width: none; /* Firefox */
    .service,
    .system,
    .order {
      margin-bottom: 44px;

      .no-data {
        height: 46px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(123, 124, 137, 1);
        line-height: 46px;
      }

      .title {
        display: flex;
        justify-content: space-between;

        color: rgba(35, 37, 58, 1);
        margin-bottom: 15px;

        .text {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }

        .more {
          cursor: pointer;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(79, 81, 97, 1);
          padding-top: 5px;
        }

        img {
          vertical-align: middle;
          height: 13px;
        }
      }

      .items {
        position: relative;

        .red {
          position: absolute;
          right: 20px;
          width: 8px;
          height: 8px;
          margin-right: 10px;
          border-radius: 50%;
          background: rgba(231, 82, 53, 1);
          box-shadow: 0px 0px 4px 0px rgba(231, 82, 53, 0.4);
        }

        cursor: pointer;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        background: #ebedf4;
        border-radius: 4px;
        margin-bottom: 10px;
        font-size: 14px;
        padding: 14px 10px;

        .el-badge__content.is-fixed {
          top: 23px;
          right: -2px;
        }
      }

      .text {
        width: 80%;
      }

      .left-icon {
        height: 16px;
        width: 16px;
      }

      .right-icon {
        width: 7px;
        height: 13px;
      }
    }
  }

  .panel {
    width: 380px;
    height: 100%;
    box-shadow: -10px 0px 20px 0px rgba(40, 54, 65, 0.15);
    background: #fff;
    padding: 25px;
    padding-top: 0px;
  }
}

@mixin cardIconClass {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  overflow: hidden;
  background: url('https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/EBOrder/close-icon.png')
    no-repeat center;
  background-size: 100%;

  &::before {
    content: none;
  }
}

.hide {
  display: none;
}

.lf {
  float: left;
}

.rf {
  float: right;
}

.card-message-class {
  width: auto;
  padding: 0;

  &.right {
    right: 70px;
  }

  .el-notification__group,
  .el-notification__content {
    margin: 0 auto;
  }

  .el-icon-close {
    @include cardIconClass();
  }
}

.order-message {
  background: #fff;
  width: 366px;

  .header {
    position: relative;
    padding: 24px 24px 16px;
    line-height: 20px;
    font-size: 18px;
    font-weight: 600;
    color: #23253a;

    &::after {
      content: '';
      clear: both;
      display: block;
    }

    .common {
      display: inline-block;
    }

    .icon {
      position: relative;
      margin-left: 8px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: url('https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/EBOrder/err-icon.png')
        no-repeat center;
      background-size: 100%;
      cursor: pointer;

      &:hover .err-message {
        display: block;
      }
    }

    .hide {
      display: none;
    }

    .err-message {
      display: none;
      position: absolute;
      top: 18px;
      left: -15px;
      padding: 15px 14px 11px;
      width: 170px;
      font-size: 14px;
      font-weight: 400;
      color: #4f5161;
      line-height: 22px;
      background: #fff;
      box-shadow: 0px 2px 8px 0px rgba(44, 57, 84, 0.15);
    }
  }

  .order-infor {
    padding: 0 24px;
  }

  .msg-list {
    margin-bottom: 12px;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    overflow: hidden;

    .item-name {
      width: 80px;
      text-align: right;
      color: #4f5161;
    }

    .item-value {
      margin-left: 86px;
      color: #23253a;
    }

    .color-text {
      color: #1f6aff;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .btn-group {
    display: flex;
    justify-content: flex-end;
    padding: 10px 24px;
    margin-top: 16px;
    border-top: 1px solid #dcdfe6;

    > span {
      margin-left: 16px;
      padding: 8px 16px;
      text-align: center;
      background: #1f6aff;
      border-radius: 4px;
      color: #fff;
      cursor: pointer;
    }
  }
}

.card-message {
  padding: 16px 24px;
  width: 366px;
  font-size: 14px;
  border-radius: 4px;
  background: #fff;

  &.right {
    right: 70px;
  }

  .el-notification__group {
    margin: 0;
  }

  .el-notification__content {
    margin-top: 0;

    p div p {
      line-height: 24px;
      color: #4f5161;
    }
  }

  .el-icon-close {
    @include cardIconClass();
  }
}
</style>
